import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-70cf3d08")
const _hoisted_1 = { class: "action-buttons" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!!_ctx.pinnedAssetData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "pinned-asset-modal",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('on-close')), ["stop"]))
      }, [
        _createElementVNode("div", {
          class: "content",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("span", {
            class: "close-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-close')))
          }, "✕"),
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("modals.pinned.confirm_unpin")), 1),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "v1-button-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-close')))
            }, _toDisplayString(_ctx.$t("buttons.cancel")), 1),
            _createElementVNode("button", {
              class: "v1-button-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.unpin(_ctx.pinnedAssetData.id)))
            }, _toDisplayString(_ctx.$t("buttons.remove")), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}